import { Document, Suggestion } from "../../../types/document";
import { BlockReference } from "./BlockReference";
import { findBlockIndexInGroups } from "../document/blockUtils";
import { PanelEmptyState } from "./PanelEmptyState";

interface BlockReferencesProps {
  document: Document;
  suggestion?: Suggestion | null;
  highlightFirst?: boolean;
  placeholder?: string;
}

export const BlockReferences = ({
  document,
  suggestion,
  highlightFirst,
  placeholder,
}: BlockReferencesProps) => {
  
  const findBlockGroup = (blockId: string) => {
    return document.groups.find((group) => group.blockIds.includes(blockId));
  };
  
  if (!suggestion?.blocks || suggestion?.blocks.length === 0) {
    return (
      <PanelEmptyState
        title="No references"
        message={placeholder || "No block references available."}
      />
    );
  }

  return (
    <>
      {suggestion.blocks.map((blockId, index) => {
        const block = document.blocks.find((b) => b.id === blockId);
        const blockGroup = findBlockGroup(blockId);

        if (!block || !blockGroup) return null;

        const blockIndex = findBlockIndexInGroups(document, blockId);
        if (blockIndex === -1) return null;

        return (
          <BlockReference
            key={blockId}
            block={block}
            index={blockIndex}
            blockGroup={blockGroup}
            highlight={(highlightFirst && index === 0) || false}
          />
        );
      })}
    </>
  );
}; 